import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import resolveIcon from '../../../images/resolved.png';
// import cross from '../../images/cross.png';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import { useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import { authKey } from '../../../common/URLs';
import Dialog from '@mui/material/Dialog';
import jwt from 'jwt-decode';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { ConfirmPopover } from '../../../preregcamps/confirmPopover/confirmPopover';
import { Container, Box, Button, TextField, Typography, Checkbox } from '@mui/material';
import { NO_DATA_AVAILABLE } from '../../../common/constants';
import { DataGrid } from '@mui/x-data-grid';
import { QuickSearchToolbar } from '../../../payment/common/commonFunctions';
import moment from 'moment';
import { VALIDATION, capitalizeFunction, openTextFieldMaxLength } from '../../../common/commonValidations';

function BundleDetailsPopOver(props) {

  const [inventory, setInventory] = useState(props.rbInventories);
  const [open, setOpen] = useState(false)
  const [open1, setOpen1] = useState(false)
  const [bundleId, setBundleId] = useState("");
  const [error, setError] = useState("");
  const [unselectReason, setUnSelectedReason] = useState("");
  const [nextSelectableIndex, setNextSelectableIndex] = useState("");
  const [highestSelectedIndex, setHighestSelectedIndex] = useState("");

  useEffect(() => {
    let indexNext = 0;
    let nextIndexFound = false;

    props.rbInventories.forEach((inv, index) => {

      if (!inv.checkVal && !inv.comment && !nextIndexFound) {
        indexNext = index;
        nextIndexFound = true;
      }
    })
    setNextSelectableIndex(indexNext)
  }, [])


  const checkVal = (inventoryRow) => {
    let inverntoryList = [...inventory];
    inverntoryList.forEach((inv, index) => {
      if (inv.bundleId === inventoryRow.bundleId) {
        inv.checkVal = inv.checkVal ? false : true;
      }
    })
    setInventory(inverntoryList);
  }

  const changeReason = (e, inv) => {
    let inventoriesList = [...inventory];
    inventoriesList.forEach(i => {
      if (i.bundleId === inv.bundleId) {
        i.comment = e.target.value;
      }
    })
    setInventory(inventoriesList);
  }

  const bambooSubmit = (e) => {
    e.preventDefault();
    const selectedIndices = inventory.map((row, index) => row.checkVal ? index : -1).filter(index => index !== -1);
    const highestIndex = Math.max(...selectedIndices);
    setHighestSelectedIndex(highestIndex);

    // Check if every index from 0 to the highest selected index is included in the selectedIndices array
    for (let i = 0; i <= highestIndex; i++) {
      console.log("index", !selectedIndices.includes(i))
      console.log("comment", inventory.find((item, findIndex) => findIndex === i).comment == null)
      if (!selectedIndices.includes(i) && inventory.find((item, findIndex) => findIndex === i).comment == null) {
        setError("Please Enter reasons for skipping the previous rows");
        return;
      }
    }
    props.inventories(inventory);
    props.handleLogModalClose();
  }

  const setReason = (e) => {
    //unselectReason = e.target.value;
    setUnSelectedReason(VALIDATION.noSpecialCharacterValidation(e.target.value))
  }

  const columns = [
    {
      field: 'rowSelect', // Change this to the actual ID field name
      headerName: '',
      width: 60,
      renderCell: (params) => (
        // <CheckBox name="rowSelect" value={params?.row?.checkVal} checked={params?.row?.checkVal} onChange={() => checkVal(params.row)} />
        <Checkbox name="rowSelect" value={params?.row?.checkVal} checked={params?.row?.checkVal} onChange={() => checkVal(params?.row)} />
      ),
    },
    { field: 'bundleId', headerName: 'Bundle ID', width: 180 },
    {
      field: 'consignmentDeliveryTimestamp', headerName: 'Receiving Date', width: 150,
      valueFormatter: params => moment(params?.value).format("DD/MM/YYYY"),
    },
    {
      field: 'arrivalWeight', headerName: 'Weight', width: 150,
      valueGetter: (params) => {
        return params.row.arrivalWeight ? params.row.arrivalWeight : params.row?.rbCbWeight
      }
    },
    {
      field: 'comment', headerName: 'Comment', width: 250,
      renderCell: (params) => {
        const handleKeyDown = (event) => {
          if (event.key === ' ') {
            event.stopPropagation(); // Stops event bubbling to prevent row selection
          }
        };
        return (
          <>
            {!params.row?.checkVal && inventory.findIndex((item) => item === params.row) < highestSelectedIndex ?
              <TextField fullWidth
                variant='standard'
                name="comment"
                multiline
                onKeyDown={handleKeyDown}
                inputProps={{
                  maxLength: openTextFieldMaxLength
                }}
                sx={{ width: "100%" }}
                size='small'
                onChange={(e) => changeReason(e, params.row)}
                value={params?.row?.comment} /> : <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', width: '100%' }}>
                {params.value}
              </div>}
          </>
        )
      },
      valueGetter: (params) => params.value
    }

  ];

  return (
    <>
      <Container maxWidth="xxl">
        <Typography variant="h5" gutterBottom>
          Bundle Details
        </Typography>
        <Typography sx={{ color: "red" }} gutterBottom>{error}</Typography>
        {inventory.length !== 0 ?
          <Box style={{ height: 400, width: '100%' }}>
            {
              inventory &&
              <DataGrid rows={inventory}
                columns={columns}
                pageSize={10}
                getRowId={(row) => row.bundleId}
                selectionModel={inventory
                  .filter(row => row.checkVal)
                  .map(row => row.bundleId)}
                components={{ Toolbar: QuickSearchToolbar }}
              />
            }
          </Box>
          : <Typography display="flex" justifyContent='center'>{NO_DATA_AVAILABLE}</Typography>
        }
        <Box display='flex' alignItems="center" justifyContent="center" mt={3} style={{ float: "right" }}>
          <Button sx={{ minWidth: 100 }} variant="contained"
            type="submit"
            value="Cancel"
            onClick={props?.handleLogModalClose}
          >Cancel</Button>
          <Button sx={{ minWidth: 100, ml: 1 }} variant="contained"
            type="submit"
            value="Submit"
            onClick={(e) => bambooSubmit(e)}
            disabled={inventory.length === 0}
          >Submit</Button>
        </Box>
      </Container>
      <Dialog
        sx={{ '& .MuiDialog-paper': { width: '80%', maxHeight: 435 } }}
        maxWidth="xs"

        open={open}

      >

        <DialogContent>
          <Typography gutterBottom>Do you really want to uncheck bundle</Typography>
          <TextField fullWidth sx={{ mt: 2 }} multiline rows={4} label='Please Enter Reason' onChange={e => setReason(e)} type="text" name="" />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              let inverntoryList = [...inventory];
              inverntoryList.forEach(inv => {
                if (inv.bundleId === bundleId) {
                  inv.checkVal = inv.checkVal ? false : true;
                  inv.comment = unselectReason;
                  setBundleId("")
                  setOpen(false)
                }

              })

              setInventory(inverntoryList);
            }}

          >Ok</Button>
          <Button onClick={e => { setOpen(false) }}>Cancel</Button>
        </DialogActions>
      </Dialog>
      <Dialog
        fullWidth
        sx={{ '& .MuiDialog-paper': { width: '80%', maxHeight: 435 } }}
        maxWidth="xs"
        open={open1}
      >
        <DialogContent>
          <Typography>Do you really want to skip previous unselected bundle ?</Typography>
          <DialogActions>
            <Button
              onClick={() => {
                let inverntoryList = [...inventory];
                inverntoryList.forEach((inv, index) => {
                  if (inv.bundleId === bundleId) {
                    inv.checkVal = inv.checkVal ? false : true;
                    // inv.reason = unselectReason;
                    setNextSelectableIndex(index + 1);
                    setBundleId("")
                    setOpen1(false)
                  }

                })

                setInventory(inverntoryList);
              }}

            >Ok</Button>
            <Button sx={{ ml: 1 }}
              onClick={e => {

                setOpen1(false)
              }}
            >Cancel</Button>
          </DialogActions>
        </DialogContent>

      </Dialog>
    </>
  );
}; export default BundleDetailsPopOver;